import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { window } from './BrowserHelpers';

var SafeAppCloseHelper =
/*#__PURE__*/
function () {
  function SafeAppCloseHelper(canCloseWindow) {
    var _this = this;

    _classCallCheck(this, SafeAppCloseHelper);

    _defineProperty(this, "onCanCloseApp", function (event, message) {
      window.electron.ipcRenderer.send('docs-are-synced', _this.canCloseWindow());
    });

    _defineProperty(this, "onBeforeUnload", function (event) {
      if (_this.canCloseWindow()) {
        return;
      } // Note Chrome just ignores the message, returning anything will prompt the user


      var confirmationMessage = "Some content is being synchronized and might be lost if you leave now.\n\nAre you sure you want to leave now?\n";
      event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+

      return confirmationMessage; // Gecko, WebKit, Chrome <34
    });

    this.canCloseWindow = canCloseWindow;
  }

  _createClass(SafeAppCloseHelper, [{
    key: "register",
    value: function register() {
      if ('electron' in window) {
        window.electron.ipcRenderer.on('can-close-app', this.onCanCloseApp);
      }

      window.addEventListener('beforeunload', this.onBeforeUnload);
    }
  }, {
    key: "unregister",
    value: function unregister() {
      if ('electron' in window) {
        window.electron.ipcRenderer.removeListener('can-close-app', this.onCanCloseApp);
      }

      window.removeEventListener('beforeunload', this.onBeforeUnload);
    }
  }]);

  return SafeAppCloseHelper;
}();

export { SafeAppCloseHelper as default };